// import { red } from '@material-ui/core/colors'

import { createTheme } from '@material-ui/core/styles'

export default createTheme({
  palette: {
    primary: {
      main: '#52b274',
      contrastText: '#fff',
    },
    secondary: {
      main: '#E91E63',
    },
  },
})
